import { Canvas } from "@react-three/fiber";
import React from "react";
import Camera from "./three/Camera";
import Cubemap from "./three/Cubemap";
import Moon from "./three/Moon";
import Props from "./three/Props";
import Spaceman from "./three/Spaceman";
import Details from "./three/Details";
import useStore from "./useStore";

const Assets = () => {
  const currentSection = useStore((state) => state.currentSection);

  return (
    <>
      <group
        dispose={null}
        position={[3, 20, 5]}
        visible={currentSection === 0}
      >
        <Spaceman posture="stand" />
      </group>
      <group
        dispose={null}
        position={[1.01, 12.01, 20.01]}
        visible={currentSection === 1}
      >
        <Props name="screen" />
        <Spaceman posture="sit" position={[9, 7, -3]} />
      </group>
      <group
        dispose={null}
        position={[1, 20, 14]}
        visible={currentSection === 2}
      >
        <Props name="plant" position={[11, 0, -6]} />
        <Spaceman posture="harvesting" rotation={[0, 1.5708, 0]} />
      </group>
      <group
        dispose={null}
        position={[5, 16.01, 16.1]}
        rotation={[-1.5708, 0, 0]}
        visible={currentSection === 3}
      >
        <Spaceman posture="lying" />
      </group>
      <group
        dispose={null}
        position={[6.1, 18.01, 13.5]}
        rotation={[0, -1.5708, 0]}
        visible={currentSection === 4}
      >
        <Spaceman posture="sit" />
      </group>
    </>
  );
};

const ThreeScene = () => {
  return (
    <Canvas
      style={{
        position: "fixed",
        top: "0",
        left: "0",
        outline: "none",
      }}
    >
      <color attach="background" args={["black"]} />
      <Camera />
      <group dispose={null} position={[0, 0, 0]} scale={0.2}>
        <Assets />
        <Details />
        <Moon />
      </group>
      {/* <Particles /> */}
      <Cubemap />
    </Canvas>
  );
};

export default ThreeScene;
